import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';

import { logout } from '../components/Auth/actionCreators';
import { onInactivityTimeOut } from '../components/Inactivity/actions';

import {
  isAuthenticated,
  isSessionExpired,
  saveLastActivityTime,
} from '../utils';

import { INACTIVITY_LOG_OUT_TIME } from '../staticData';

function useUserInactivity() {
  const location = useLocation();
  const dispatch = useDispatch();

  const timerRef = useRef();

  const clearTimer = () => timerRef.current && clearTimeout(timerRef.current);
  const setTimer = () => {
    clearTimer();
    timerRef.current = setTimeout(
      () => onInactivityTimeOut(dispatch),
      INACTIVITY_LOG_OUT_TIME,
    );
  };

  useEffect(() => {
    if (isSessionExpired()) {
      logout(dispatch);
    }
    if (isAuthenticated()) {
      setTimer();
    }
    saveLastActivityTime();
    return () => clearTimer();
  }, [location]);
}

export default useUserInactivity;
